import { useMemo } from 'react';
import { Skeleton } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useComposerData } from '../../../ComposerDataProvider';
import { StyledChip } from './styled';
export function FilterChip(props) {
    const { label, selected, onAdd, onRemove } = props;
    const { loading } = useComposerData();
    const toggle = selected ? onRemove : onAdd;
    const width = useMemo(() => Math.random() * (9 - 4) + 4, []);
    return (<Skeleton loading={loading} width={`${width}rem`}>
      <StyledChip onClick={toggle} appearance="secondary" label={label} variant={selected ? 'solid' : 'outline'} icon={selected ? <Falcon icon="check"/> : undefined}/>
    </Skeleton>);
}
